<div class="section-wrapper">
  <span class="section-title">Category</span>

  <p-accordion [multiple]="false">
    <div *ngFor="let specification of specificationData">
      <p-accordionTab class="section-title" header={{specification.CategoryName}}>
        <div *ngFor="let imgSpecificationData of specification.LstCategoryRuleGroupedByCategoryId">
          <label>
            <div *ngFor="let imgSpecification of imgSpecificationData.CategoryMappingRuleFiles">
              <input type="checkbox" value="imgSpecificationData.RuleId" [disabled]="!(imgSpecificationData.IsActive)"
                (change)="submitCheckedLifeSavingValue(imgSpecificationData, $event)"
                [checked]="imgSpecificationData.Checked" pTooltip={{imgSpecificationData.RuleName}}>
              <img src={{imgSpecification.FilePath}} alt="img" width="28px" height="28px"
                pTooltip={{imgSpecificationData.RuleName}}>
            </div>
          </label>
        </div>
      </p-accordionTab>
    </div>
    <div *ngIf="specificationData.length===0">
      No Categories are configured for {{moduleName}}
    </div>
  </p-accordion>
</div>
